"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icon = exports.select = void 0;

var _util = require("../../../util");

const select = ({
  theme
}) => {
  const {
    selects
  } = theme;
  return { ...(0, _util.textStyle)(theme, selects.textStyle),
    background: (0, _util.color)(theme, selects.background),
    borderRadius: selects.borderRadius,
    color: (0, _util.color)(theme, selects.color),
    fontWeight: theme.fontWeights.bold,
    height: selects.height,
    padding: (0, _util.spacing)(theme, selects.padding),
    '-webkit-appearance': 'none',
    '&:not(:disabled):hover': {
      background: (0, _util.color)(theme, selects.backgroundHover)
    },
    '&:disabled': {
      background: (0, _util.color)(theme, selects.backgroundDisabled)
    }
  };
};

exports.select = select;

const icon = ({
  theme
}) => ({
  marginLeft: "-".concat((0, _util.spacing)(theme, 'xlarge'), "px"),
  pointerEvents: 'none'
});

exports.icon = icon;
//# sourceMappingURL=Select.style.js.map